// Demo-only (am-tp-demo user groups) — delete after the TP demo. Not a real-feature surface.
import { TAffiliateUserGroupsResponse } from '@commenda/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

export function useAffiliateUserGroups(affiliateFirmId: string | null) {
  const { data, error, isLoading, mutate } =
    useSWR<TAffiliateUserGroupsResponse>(
      affiliateFirmId
        ? `demo/affiliate-firms/${affiliateFirmId}/user-groups`
        : null,
      SWRFetcher({
        method: 'GET',
      })
    );

  return {
    data,
    error,
    isLoading,
    mutate,
  };
}
